import { connect } from 'react-redux'
import { getFormValues, change } from 'redux-form'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core'

import { PassengerFieldsBase } from './PassengerFields'

import { passengerActions } from 'reduxModules/actions/PassengerActions'
import { modalActions } from 'reduxModules/actions/ModalActions'
import { fromCityTypeSelector } from 'reduxModules/selectors/CitySelectors'
import {
  bookingsLengthSelector,
  bookingsBlacklistLengthSelector,
  isLoadingSelector
} from 'reduxModules/selectors/PassengerSelectors'

import { styles } from './styles'

const mapStateToProps = (state, props) => ({
  bookingsLength: bookingsLengthSelector(state, props),
  bookingsBlacklistLength: bookingsBlacklistLengthSelector(state, props),
  isLoading: isLoadingSelector(state, props),
  fromCityType: fromCityTypeSelector(state, props),
  bookForm: getFormValues('book')(state),
})

const mapDispatchToProps = {
  changeFormField: change,
  showModal: modalActions.showModal,
  getPassenger: passengerActions.getPassenger
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const PassengerFields = enhance(PassengerFieldsBase)



// WEBPACK FOOTER //
// ./src/components/PassengerFields/index.js